export default __webpack_public_path__ + "static/media/loading.ead2a800.gif";